import { updateUserByRV } from "../../actions";

const EStatus = {
  callback: 0,
  filaDeEspera: 1,
  retornando: 5,
  retornando2: 2,
};

export const verifyIfCallIsStillInQueue = (queueid) => {
  return (dispatch, getState) => {
    try {
      const { listcallqueue } = getState();
      return (
        Array.isArray(listcallqueue) &&
        listcallqueue.some(
          (call) =>
            parseInt(call.queueid) === parseInt(queueid) &&
            parseInt(call.status) === EStatus.callback,
        )
      );
    } catch (error) {
      return false;
    }
  };
};

export const EAgentStatus = {
  Livre: "Livre",
  Pausado: "Pausado",
  Aftercallwork: "Aftercallwork",
  Ligacao: "Ligação",
  Atendimento: "Atendimento",
  Discando: "Discando",
  Chamando: "Chamando",
  ChamandoChat: "ChamandoChat",
};

export const verifyIfStatusStillLV = () => {
  return (dispatch, getState) => {
    try {
      const { status: StatusAgent } = getState();
      return Boolean(StatusAgent) && StatusAgent.status === EAgentStatus.Livre;
    } catch (error) {
      return false;
    }
  };
};

export const changeAgentStatusToRV = () => {
  return async (dispatch, getState) => {
    try {
      const { informationusers: InfoUsers } = getState();
      const sipId = InfoUsers.sipid || null;
      if (!Boolean(sipId)) return;
      const respose = await updateUserByRV(sipId);
      return respose;
      //chamar o end-point para mudar o status
    } catch (error) {
      return false;
    }
  };
};
